import { CommentEntity } from 'mk2/apps/blogs/schemas';
import {
    initialPostDetailPageState,
    initialPostDetailState,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.constants';
import {
    PostDetailPageState,
    PostDetailState,
    PostDetailVirtualPageState,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.reducers';
import { getTopicTopic } from 'mk2/apps/forum/containers/Topic/Topic.selectors';
import { MicroPostEntity, PostEntity, PostSchema, TopicEntity } from 'mk2/apps/forum/schemas';
import { ComplaintState, getShow } from 'mk2/containers/Complaint/Complaint.reducers';
import { AppState } from 'mk2/reducers';
import * as fromEntities from 'mk2/reducers/entities';
import { createDenormalizedEntitiesSelector } from 'mk2/selectors';
import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';

export const getPostDetailPost = createSelector(
    [
        (state: AppState) => state.entities,
        (state: AppState, postSlug: string) => postSlug,
        (state: AppState, postSlug: string, topicSlug: string) => getTopicTopic(state, topicSlug),
    ],
    (entities: fromEntities.EntitiesState, postSlug: string, topic: TopicEntity): PostEntity => {
        if (!entities[PostSchema.key]) {
            return null;
        }

        const postsIds = Object.keys(entities[PostSchema.key]);
        const posts = denormalize(postsIds, [PostSchema], entities);

        return posts.find((post) => post.slug === postSlug && post.topic.id === topic.id);
    },
);
export const getForumPostDetailState = (state: AppState, topicSlug: string, postSlug: string): PostDetailState =>
    state.containers.forum.forumPostDetail[`${topicSlug}/${postSlug}`] || initialPostDetailState;
export const getForumPostDetailPageState = (state: AppState, topicSlug: string, postSlug: string, page: number): PostDetailPageState =>
    getForumPostDetailState(state, topicSlug, postSlug).pages[page] || initialPostDetailPageState;
export const getForumPostDetailVirtualPageState = (state: AppState, topicSlug: string, postSlug: string, pageName: string): PostDetailVirtualPageState =>
    getForumPostDetailState(state, topicSlug, postSlug).virtualPages[pageName] || initialPostDetailPageState;

export const getDenormalizedComments = createDenormalizedEntitiesSelector<CommentEntity>();
export const getDenormalizedCommentsWithComplaint = createDenormalizedEntitiesSelector<CommentEntity>();
export const getDenormalizedMicroPosts = createDenormalizedEntitiesSelector<MicroPostEntity>();
export const getComplaintShowCached = createSelector(
    [
        (state: AppState, comments: CommentEntity[]) => state.containers.global.complaint,
        (state: AppState, comments: CommentEntity[]) => comments,
    ],
    (complaintState: ComplaintState, comments: CommentEntity[]) => {
        if (!comments.length) {
            return [];
        }

        return comments.map((c) => getShow(complaintState, 'forum-message', c.id));
    },
);
